import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import StyledComponent from "./Styled";
import { toUnionType } from "../../Common/UnionType";
/**
 * moaui Styled Separator
 *
 * @param {MoaSeparatorProps} props - direction
 * @example
 * <Separator
 * 	direction={"horizontal" || "vertical"}
 * />
 * @returns {React.ReactElement} MoaSeparator
 */
var Separator = function (props) { return (_jsx(StyledComponent, __assign({}, props))); };
Separator.defaultProps = {
    direction: "horizontal"
};
var SampleProps = {
    direction: toUnionType({ values: ['horizontal', 'vertical'] }),
};
export default Separator;
export { SampleProps as SeparatorSample, };
